import { useEffect } from 'react';

/**
 * What the browser tab, the history list and a screen reader's "page title"
 * call this screen. One product-wide title for every screen left somebody
 * with six tabs open unable to tell the book from the reports.
 */
export function useDocumentTitle(title: string): void {
    useEffect(() => {
        const previous = document.title;
        document.title = title;
        return () => { document.title = previous; };
    }, [title]);
}

export const titled = (...parts: (string | null | undefined)[]): string =>
    [...parts.filter((p): p is string => !!p && p.trim() !== ''), 'Timely Payment'].join(' — ');
